/**
 * Complaint export column headers (must match backend registry).
 */

export const COMPLAINT_EXPORT_COLUMN_HEADERS = [
  'Complaint ID',
  'Title',
  'Category',
  'Details',
  'Status',
  'Severity',
  'Hours Spent',
  'Closing Remarks',
  'Cancellation Reason',
  'Created At',
  'Updated At',
  'Closed At',
  'Acknowledged At',
  'Device ID',
  'Device Name',
  'Serial Number',
  'Department',
  'Location Name',
  'Reporter Name',
  'Reporter Email',
  'Reporter Contact',
  'Assigned To',
  'Assigned Email',
  'Assigned Phone',
  'Impacts Availability',
  'Spare Parts Required',
  'Authenticated Reporter',
  'Acknowledge Due',
  'Closure Target',
  'Ack Escalated At',
  'Closure Escalated At',
];

export const COMPLAINT_EXPORT_EXCEL_DEFAULT_HEADERS = new Set([
  'Complaint ID',
  'Title',
  'Category',
  'Status',
  'Severity',
  'Device Name',
  'Department',
  'Location Name',
  'Created At',
  'Assigned To',
]);

/** Keep in sync with COMPLAINT_EXPORT_EXCEL_DEFAULT_HEADERS (shared picker). */
export const COMPLAINT_EXPORT_PDF_DEFAULT_HEADERS = new Set([
  ...COMPLAINT_EXPORT_EXCEL_DEFAULT_HEADERS,
]);

export const createComplaintExportColumnsState = (format = 'excel') => {
  const defaults =
    format === 'pdf'
      ? COMPLAINT_EXPORT_PDF_DEFAULT_HEADERS
      : COMPLAINT_EXPORT_EXCEL_DEFAULT_HEADERS;
  return COMPLAINT_EXPORT_COLUMN_HEADERS.reduce((acc, header) => {
    acc[header] = defaults.has(header);
    return acc;
  }, {});
};

export const getSelectedExportColumnHeaders = (exportColumns) =>
  Object.entries(exportColumns)
    .filter(([, enabled]) => enabled !== false)
    .map(([header]) => header);
